/**
 * Composable for handling app store redirects
 */

export function useAppRedirect() {
  /**
   * Redirect to app store link
   * @param url - App store URL
   */
  function redirectToApp(url: string) {
    if (typeof window !== 'undefined') {
      window.open(url, '_blank', 'noopener,noreferrer')
    }
  }

  return {
    redirectToApp,
  }
}
